// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.rg-celleditor-input, .rg-celleditor input {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background: transparent;
  font-size: 1em;
  outline: none;
}

.rg-celleditor {
  box-sizing: border-box;
  z-index: 5;
  background-color: #ffffff;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.06);
  display: flex;
  border-style: solid;
  border-color: #3579f8;
  border-width: 2px;
  padding: 0 4px;
}
.rg-number-celleditor input {
  text-align: right;
}

.reactgrid-content .rg-pane .rg-cell.rg-number-cell,
.reactgrid-content .rg-pane .rg-cell .rg-time-cell,
.reactgrid-content .rg-pane .rg-cell .rg-date-cell {
  justify-content: flex-end;
}
.reactgrid-content .rg-pane .rg-cell.rg-email-cell.rg-invalid {
  color: rgb(255, 0, 0);
}
.reactgrid-content .rg-pane .rg-cell.rg-text-cell.placeholder {
  color: #999;
  font-size: 0.8em;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell {
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  background: transparent;
  pointer-events: auto;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell input {
  width: 20px;
  height: 20px;
}
.reactgrid-content .rg-pane .rg-cell.rg-chevron-cell .chevron {
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-right: 0.1em;
  cursor: pointer;
  transition: 200ms all ease-in-out;
  height: 1em;
  width: 1em;
}
.reactgrid-content .rg-pane .rg-cell.rg-chevron-cell .no-child {
  width: 0.5em;
}
.reactgrid-content .rg-pane .rg-cell.rg-chevron-cell.expanded .chevron {
  transform: rotate(90deg);
}
.reactgrid-content .rg-pane .rg-cell.rg-chevron-cell.collapsed .chevron {
  transform: rotate(0deg);
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell {
  justify-content: center;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label {
  position: relative;
  height: 18px;
  width: 18px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  margin: 0;
  height: 18px;
  width: 18px;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell span {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #eeeeee;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label:hover input ~ span {
  background-color: #cccccc;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label input:checked ~ span {
  background-color: #3579f8;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell span:after {
  content: "";
  position: absolute;
  display: none;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label input:checked ~ span:after {
  display: block;
}
.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label span:after {
  left: 5px;
  top: 0px;
  width: 4px;
  height: 12px;
  border: solid #ffffff;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell {
  padding: 0;
  overflow: visible;
}
.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell .rg-dropdown-menu {
  top: 100%;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.5);
  margin-bottom: 8px;
  margin-top: 2px;
  position: absolute;
  width: 100%;
  z-index: 1;
  box-sizing: border-box;
}
.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell .rg-dropdown-option {
  padding: 0.3em 0.5em;
  min-height: 1.5em;
  display: flex;
  align-items: center;
}
.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell .rg-dropdown-option.selected::before {
  content: "✓";
  padding-right: 0.2em;
}
.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell .rg-dropdown-option.focused {
  color: black;
  background-color: #e2ebfe;
}

[contenteditable] {
  -webkit-user-select: text;
  user-select: text;
}

.reactgrid-content {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}
.reactgrid-content .rg-pane.rg-pane-top, .reactgrid-content .rg-pane.rg-pane-bottom, .reactgrid-content .rg-pane.rg-pane-left, .reactgrid-content .rg-pane.rg-pane-right {
  position: sticky;
  position: -webkit-sticky;
  background-color: #ffffff;
}
.reactgrid-content .rg-pane.rg-pane-top {
  top: 0;
}
.reactgrid-content .rg-pane.rg-pane-bottom {
  bottom: 0;
}
.reactgrid-content .rg-pane.rg-pane-left {
  left: 0;
}
.reactgrid-content .rg-pane.rg-pane-right {
  right: 0;
}
.reactgrid-content .rg-pane .rg-cell {
  font-size: 1em;
  box-sizing: border-box;
  white-space: nowrap;
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  padding: 0 4px;
  outline: none;
  touch-action: auto;
  border-color: #e8e8e8;
}
.reactgrid-content .rg-pane .rg-cell .rg-touch-resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 11px;
  height: 100%;
  pointer-events: auto;
}
.reactgrid-content .rg-pane .rg-cell .rg-touch-resize-handle .rg-resize-handle {
  position: absolute;
  right: 0;
  width: 6px;
  height: 100%;
}
.reactgrid-content .rg-pane .rg-cell .rg-touch-resize-handle .rg-resize-handle:hover {
  cursor: col-resize;
  background-color: #3579f8;
}
.reactgrid-content .rg-pane .rg-cell .rg-groupId {
  font-size: 0.8em;
  position: absolute;
  right: 4px;
  top: 4px;
}
.reactgrid-content .rg-pane .rg-cell-focus,
.reactgrid-content .rg-pane .rg-cell-highlight {
  position: absolute;
  pointer-events: none;
  box-sizing: border-box;
  border-style: solid;
  border-width: 2px;
  border-color: #3579f8;
}
.reactgrid-content .rg-pane .rg-touch-fill-handle {
  position: absolute;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.01);
  touch-action: none;
  pointer-events: auto;
}
.reactgrid-content .rg-pane .rg-touch-fill-handle .rg-fill-handle {
  position: absolute;
  cursor: crosshair;
  top: 50%;
  left: 50%;
  transform: translate(calc(-50% - (1px/ 2)), calc(-50% - (1px/ 2)));
  width: 6.5px;
  height: 6.5px;
  background-color: #3579f8;
  border-width: 1px;
  border-style: solid;
  border-color: #ffffff;
  background-clip: content-box;
}
.reactgrid-content .rg-pane .rg-partial-area {
  position: absolute;
  pointer-events: none;
  box-sizing: border-box;
}
.reactgrid-content .rg-pane .rg-partial-area.rg-partial-area-part {
  border-width: 1px;
  border-style: dashed;
  border-color: #000000;
}
.reactgrid-content .rg-pane .rg-partial-area.rg-partial-area-selected-range {
  border-width: 1px;
  border-style: solid;
  border-color: #3579f8;
  background-color: rgba(53, 121, 248, 0.35);
}
.reactgrid-content .rg-pane-shadow {
  position: sticky;
}
.reactgrid-content .rg-pane-shadow.shadow-top {
  pointer-events: none;
  top: 0;
  box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.06);
}
.reactgrid-content .rg-pane-shadow.shadow-left {
  pointer-events: none;
  left: 0;
  box-shadow: 5px 0 3px -2px rgba(0, 0, 0, 0.06);
}
.reactgrid-content .rg-pane-shadow.shadow-bottom {
  pointer-events: none;
  bottom: 0;
  box-shadow: 2px -1px 3px 1px rgba(0, 0, 0, 0.06);
}
.reactgrid-content .rg-pane-shadow.shadow-right {
  pointer-events: none;
  right: 0;
  box-shadow: -5px 0 3px -2px rgba(0, 0, 0, 0.06);
}
.reactgrid-content .rg-pane-shadow.shadow-top-left-corner {
  box-shadow: 2px 3px 3px 1px rgba(0, 0, 0, 0.06);
}
.reactgrid-content .rg-pane-shadow.shadow-top-right-corner {
  box-shadow: -2px 2px 3px 1px rgba(0, 0, 0, 0.06);
}
.reactgrid-content .rg-pane-shadow.shadow-bottom-left-corner {
  box-shadow: 2px -2px 3px 1px rgba(0, 0, 0, 0.06);
}
.reactgrid-content .rg-pane-shadow.shadow-bottom-right-corner {
  box-shadow: -2px -2px 3px 1px rgba(0, 0, 0, 0.06);
}
.reactgrid-content .rg-context-menu {
  position: fixed;
  z-index: 1000;
  background-color: #ffffff;
  font-size: 1em;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.06);
}
.reactgrid-content .rg-context-menu .rg-context-menu-option {
  padding: 8px 20px 8px 15px;
  cursor: pointer;
}
.reactgrid-content .rg-context-menu .rg-context-menu-option:hover {
  background-color: #f2f2f2;
}
.reactgrid-content .rg-shadow {
  position: absolute;
  background-color: #000000;
  opacity: 0.1;
  z-index: 4;
}
.reactgrid-content .rg-column-resize-hint {
  background-color: #74b9ff;
  position: absolute;
  padding: 5px;
  border-radius: 0 5px 5px 0;
}
.reactgrid-content .rg-line {
  position: absolute;
  background-color: #74b9ff;
  z-index: 4;
}
.reactgrid-content .rg-line-horizontal {
  left: 0;
  height: 2px;
}
.reactgrid-content .rg-line-vertical {
  top: 0;
  width: 2px;
}
.reactgrid-content .rg-hidden-element {
  border: 0;
  padding: 0;
  margin: 0;
  position: fixed;
  width: 1px;
  height: 1px;
  opacity: 0;
  top: 50%;
  left: 50%;
}`, "",{"version":3,"sources":["webpack://./node_modules/@silevis/reactgrid/styles.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,yBAAyB;EACzB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,WAAW;EACX,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,kEAAkE;EAClE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,MAAM;EACN,+CAA+C;AACjD;AACA;EACE,oBAAoB;EACpB,OAAO;EACP,8CAA8C;AAChD;AACA;EACE,oBAAoB;EACpB,SAAS;EACT,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE,MAAM;EACN,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,UAAU;EACV,WAAW;EACX,UAAU;EACV,QAAQ;EACR,SAAS;AACX","sourcesContent":["@charset \"UTF-8\";\n.rg-celleditor-input, .rg-celleditor input {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  font-size: 1em;\n  outline: none;\n}\n\n.rg-celleditor {\n  box-sizing: border-box;\n  z-index: 5;\n  background-color: #ffffff;\n  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.06);\n  display: flex;\n  border-style: solid;\n  border-color: #3579f8;\n  border-width: 2px;\n  padding: 0 4px;\n}\n.rg-number-celleditor input {\n  text-align: right;\n}\n\n.reactgrid-content .rg-pane .rg-cell.rg-number-cell,\n.reactgrid-content .rg-pane .rg-cell .rg-time-cell,\n.reactgrid-content .rg-pane .rg-cell .rg-date-cell {\n  justify-content: flex-end;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-email-cell.rg-invalid {\n  color: rgb(255, 0, 0);\n}\n.reactgrid-content .rg-pane .rg-cell.rg-text-cell.placeholder {\n  color: #999;\n  font-size: 0.8em;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell {\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  pointer-events: auto;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell input {\n  width: 20px;\n  height: 20px;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-chevron-cell .chevron {\n  pointer-events: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  margin-right: 0.1em;\n  cursor: pointer;\n  transition: 200ms all ease-in-out;\n  height: 1em;\n  width: 1em;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-chevron-cell .no-child {\n  width: 0.5em;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-chevron-cell.expanded .chevron {\n  transform: rotate(90deg);\n}\n.reactgrid-content .rg-pane .rg-cell.rg-chevron-cell.collapsed .chevron {\n  transform: rotate(0deg);\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell {\n  justify-content: center;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label {\n  position: relative;\n  height: 18px;\n  width: 18px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  margin: 0;\n  height: 18px;\n  width: 18px;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell span {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: #eeeeee;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label:hover input ~ span {\n  background-color: #cccccc;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label input:checked ~ span {\n  background-color: #3579f8;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell span:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label input:checked ~ span:after {\n  display: block;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-checkbox-cell label span:after {\n  left: 5px;\n  top: 0px;\n  width: 4px;\n  height: 12px;\n  border: solid #ffffff;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell {\n  padding: 0;\n  overflow: visible;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell .rg-dropdown-menu {\n  top: 100%;\n  background-color: #ffffff;\n  border-radius: 4px;\n  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.5);\n  margin-bottom: 8px;\n  margin-top: 2px;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n  box-sizing: border-box;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell .rg-dropdown-option {\n  padding: 0.3em 0.5em;\n  min-height: 1.5em;\n  display: flex;\n  align-items: center;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell .rg-dropdown-option.selected::before {\n  content: \"✓\";\n  padding-right: 0.2em;\n}\n.reactgrid-content .rg-pane .rg-cell.rg-dropdown-cell .rg-dropdown-option.focused {\n  color: black;\n  background-color: #e2ebfe;\n}\n\n[contenteditable] {\n  -webkit-user-select: text;\n  user-select: text;\n}\n\n.reactgrid-content {\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.reactgrid-content .rg-pane.rg-pane-top, .reactgrid-content .rg-pane.rg-pane-bottom, .reactgrid-content .rg-pane.rg-pane-left, .reactgrid-content .rg-pane.rg-pane-right {\n  position: sticky;\n  position: -webkit-sticky;\n  background-color: #ffffff;\n}\n.reactgrid-content .rg-pane.rg-pane-top {\n  top: 0;\n}\n.reactgrid-content .rg-pane.rg-pane-bottom {\n  bottom: 0;\n}\n.reactgrid-content .rg-pane.rg-pane-left {\n  left: 0;\n}\n.reactgrid-content .rg-pane.rg-pane-right {\n  right: 0;\n}\n.reactgrid-content .rg-pane .rg-cell {\n  font-size: 1em;\n  box-sizing: border-box;\n  white-space: nowrap;\n  position: absolute;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n  padding: 0 4px;\n  outline: none;\n  touch-action: auto;\n  border-color: #e8e8e8;\n}\n.reactgrid-content .rg-pane .rg-cell .rg-touch-resize-handle {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 11px;\n  height: 100%;\n  pointer-events: auto;\n}\n.reactgrid-content .rg-pane .rg-cell .rg-touch-resize-handle .rg-resize-handle {\n  position: absolute;\n  right: 0;\n  width: 6px;\n  height: 100%;\n}\n.reactgrid-content .rg-pane .rg-cell .rg-touch-resize-handle .rg-resize-handle:hover {\n  cursor: col-resize;\n  background-color: #3579f8;\n}\n.reactgrid-content .rg-pane .rg-cell .rg-groupId {\n  font-size: 0.8em;\n  position: absolute;\n  right: 4px;\n  top: 4px;\n}\n.reactgrid-content .rg-pane .rg-cell-focus,\n.reactgrid-content .rg-pane .rg-cell-highlight {\n  position: absolute;\n  pointer-events: none;\n  box-sizing: border-box;\n  border-style: solid;\n  border-width: 2px;\n  border-color: #3579f8;\n}\n.reactgrid-content .rg-pane .rg-touch-fill-handle {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  background-color: rgba(255, 255, 255, 0.01);\n  touch-action: none;\n  pointer-events: auto;\n}\n.reactgrid-content .rg-pane .rg-touch-fill-handle .rg-fill-handle {\n  position: absolute;\n  cursor: crosshair;\n  top: 50%;\n  left: 50%;\n  transform: translate(calc(-50% - (1px/ 2)), calc(-50% - (1px/ 2)));\n  width: 6.5px;\n  height: 6.5px;\n  background-color: #3579f8;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #ffffff;\n  background-clip: content-box;\n}\n.reactgrid-content .rg-pane .rg-partial-area {\n  position: absolute;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n.reactgrid-content .rg-pane .rg-partial-area.rg-partial-area-part {\n  border-width: 1px;\n  border-style: dashed;\n  border-color: #000000;\n}\n.reactgrid-content .rg-pane .rg-partial-area.rg-partial-area-selected-range {\n  border-width: 1px;\n  border-style: solid;\n  border-color: #3579f8;\n  background-color: rgba(53, 121, 248, 0.35);\n}\n.reactgrid-content .rg-pane-shadow {\n  position: sticky;\n}\n.reactgrid-content .rg-pane-shadow.shadow-top {\n  pointer-events: none;\n  top: 0;\n  box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.06);\n}\n.reactgrid-content .rg-pane-shadow.shadow-left {\n  pointer-events: none;\n  left: 0;\n  box-shadow: 5px 0 3px -2px rgba(0, 0, 0, 0.06);\n}\n.reactgrid-content .rg-pane-shadow.shadow-bottom {\n  pointer-events: none;\n  bottom: 0;\n  box-shadow: 2px -1px 3px 1px rgba(0, 0, 0, 0.06);\n}\n.reactgrid-content .rg-pane-shadow.shadow-right {\n  pointer-events: none;\n  right: 0;\n  box-shadow: -5px 0 3px -2px rgba(0, 0, 0, 0.06);\n}\n.reactgrid-content .rg-pane-shadow.shadow-top-left-corner {\n  box-shadow: 2px 3px 3px 1px rgba(0, 0, 0, 0.06);\n}\n.reactgrid-content .rg-pane-shadow.shadow-top-right-corner {\n  box-shadow: -2px 2px 3px 1px rgba(0, 0, 0, 0.06);\n}\n.reactgrid-content .rg-pane-shadow.shadow-bottom-left-corner {\n  box-shadow: 2px -2px 3px 1px rgba(0, 0, 0, 0.06);\n}\n.reactgrid-content .rg-pane-shadow.shadow-bottom-right-corner {\n  box-shadow: -2px -2px 3px 1px rgba(0, 0, 0, 0.06);\n}\n.reactgrid-content .rg-context-menu {\n  position: fixed;\n  z-index: 1000;\n  background-color: #ffffff;\n  font-size: 1em;\n  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.06);\n}\n.reactgrid-content .rg-context-menu .rg-context-menu-option {\n  padding: 8px 20px 8px 15px;\n  cursor: pointer;\n}\n.reactgrid-content .rg-context-menu .rg-context-menu-option:hover {\n  background-color: #f2f2f2;\n}\n.reactgrid-content .rg-shadow {\n  position: absolute;\n  background-color: #000000;\n  opacity: 0.1;\n  z-index: 4;\n}\n.reactgrid-content .rg-column-resize-hint {\n  background-color: #74b9ff;\n  position: absolute;\n  padding: 5px;\n  border-radius: 0 5px 5px 0;\n}\n.reactgrid-content .rg-line {\n  position: absolute;\n  background-color: #74b9ff;\n  z-index: 4;\n}\n.reactgrid-content .rg-line-horizontal {\n  left: 0;\n  height: 2px;\n}\n.reactgrid-content .rg-line-vertical {\n  top: 0;\n  width: 2px;\n}\n.reactgrid-content .rg-hidden-element {\n  border: 0;\n  padding: 0;\n  margin: 0;\n  position: fixed;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  top: 50%;\n  left: 50%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
